/**
 * Simple Countdown Timer for FOMO effects
 * Supports instant rendering, daily/fixed modes, and self-healing across Section morphs/re-renders
 */

function initCountdown(elementOrId, endType = 'daily', fixedDate = '') {
  let countdown = null;
  if (typeof elementOrId === 'string') {
    countdown = document.getElementById(elementOrId);
  } else if (elementOrId instanceof HTMLElement) {
    countdown = elementOrId;
  }
  if (!countdown) return;

  const timeDisplay = countdown.matches('[data-time-remaining]')
    ? countdown
    : countdown.querySelector('[data-time-remaining]');
  if (!timeDisplay) return;

  // Resolve settings from data attributes if not passed explicitly
  if (!endType || endType === 'daily') {
    endType = countdown.getAttribute('data-end-type') ||
              (countdown.parentElement && countdown.parentElement.getAttribute('data-end-type')) ||
              'daily';
  }
  if (!fixedDate) {
    fixedDate = countdown.getAttribute('data-fixed-date') ||
                (countdown.parentElement && countdown.parentElement.getAttribute('data-fixed-date')) ||
                '';
  }

  function getEndTime() {
    let targetTime;
    if (endType === 'fixed' && fixedDate) {
      targetTime = new Date(fixedDate).getTime();
      // If fixed date is invalid or in the past, fallback to daily midnight
      if (isNaN(targetTime) || targetTime <= Date.now()) {
        const now = new Date();
        targetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();
      }
    } else {
      // Daily reset at midnight (23:59:59)
      const now = new Date();
      targetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();
    }
    return targetTime;
  }

  let endTime = getEndTime();

  function renderTime() {
    const now = Date.now();
    let distance = endTime - now;

    if (distance <= 0) {
      if (endType === 'daily') {
        // Reset for the next day's midnight
        const nextDay = new Date();
        endTime = new Date(nextDay.getFullYear(), nextDay.getMonth(), nextDay.getDate() + 1, 23, 59, 59).getTime();
        distance = endTime - now;
      } else {
        timeDisplay.innerHTML = '<span class="timer-cap"><span class="timer-val">00</span><span class="timer-unit">H</span></span><span class="timer-col">:</span><span class="timer-cap"><span class="timer-val">00</span><span class="timer-unit">M</span></span><span class="timer-col">:</span><span class="timer-cap"><span class="timer-val">00</span><span class="timer-unit">S</span></span>';
        if (countdown._timerInterval) {
          clearInterval(countdown._timerInterval);
          countdown._timerInterval = null;
        }
        return;
      }
    }

    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const hStr = hours < 10 ? '0' + hours : '' + hours;
    const mStr = minutes < 10 ? '0' + minutes : '' + minutes;
    const sStr = seconds < 10 ? '0' + seconds : '' + seconds;

    timeDisplay.innerHTML =
      '<span class="timer-cap"><span class="timer-val">' + hStr + '</span><span class="timer-unit">H</span></span>' +
      '<span class="timer-col">:</span>' +
      '<span class="timer-cap"><span class="timer-val">' + mStr + '</span><span class="timer-unit">M</span></span>' +
      '<span class="timer-col">:</span>' +
      '<span class="timer-cap"><span class="timer-val">' + sStr + '</span><span class="timer-unit">S</span></span>';
  }

  // Clear existing timer if any on this element
  if (countdown._timerInterval) {
    clearInterval(countdown._timerInterval);
    countdown._timerInterval = null;
  }

  // Immediate first render (zero initial delay)
  renderTime();
  countdown._timerInterval = setInterval(renderTime, 1000);
}

// Global expose
window.initCountdown = initCountdown;

// Auto-discovery helper
function autoInitAllCountdowns(root = document) {
  const timers = root.querySelectorAll(
    '.shirts-countdown__timer, .product-countdown__timer, .shirts-countdown, .product-countdown, [data-countdown-timer]'
  );
  timers.forEach((el) => {
    // If it's a wrapper, target its inner timer element or itself
    const target = el.classList.contains('shirts-countdown') || el.classList.contains('product-countdown')
      ? (el.querySelector('.shirts-countdown__timer, .product-countdown__timer') || el)
      : el;

    if (target && !target._timerInterval) {
      initCountdown(target);
    }
  });
}

// Self-init on DOM readiness
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => autoInitAllCountdowns());
} else {
  autoInitAllCountdowns();
}

window.addEventListener('load', () => autoInitAllCountdowns());

// Listen for Shopify Section lifecycle events
document.addEventListener('shopify:section:load', (e) => {
  autoInitAllCountdowns(e.target || document);
});
document.addEventListener('shopify:section:select', (e) => {
  autoInitAllCountdowns(e.target || document);
});

// MutationObserver to auto-catch any newly inserted timer elements (Section morphs, HotReload, Variant switch)
if (typeof MutationObserver !== 'undefined') {
  const timerObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1) {
          if (node.matches && (node.matches('.shirts-countdown, .product-countdown, .shirts-countdown__timer, .product-countdown__timer, [data-countdown-timer]') || node.querySelector('.shirts-countdown, .product-countdown, [data-time-remaining]'))) {
            autoInitAllCountdowns(node.parentElement || document);
          }
        }
      }
    }
  });

  if (document.body) {
    timerObserver.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      timerObserver.observe(document.body, { childList: true, subtree: true });
    });
  }
}
